import styled, { css } from 'styled-components';
import { getColor } from 'core/utils/Styles';
import { align, size, resetBtn } from 'styled-manila';
import { Button as Btn } from './SignIn/signInStyles';

export const Wrapper = styled.div`
	color: ${getColor('gray8')};
	padding-bottom: 16px;
`;

export const Button = styled(Btn)`
	width: 100%;
	margin-top: 10px;
`;

export const Footer = styled.div`
	margin-top: 15px;
	padding-top: 15px;
	border-top: 1px solid ${getColor('gray3')};
	display: flex;
	justify-content: center;
	font-weight: 600;
	font-size: 14px;
	/* stylelint-disable */
	${props => props.fullWidth && css`
		width: calc(100% + 30px);
		margin-left: -15px;
	`}
	/* stylelint-enable */
`;

export const Bold = styled.strong`
	font-weight: 600;
`;

export const Cta = styled.button`
	${resetBtn}
	margin-left: 5px;
	color: ${getColor('limedSpruceGray')};

	&:hover, &:focus {
		color: ${getColor('limedHover')};
	}

	&[disabled] {
		cursor: not-allowed;
		opacity: 0.8;
	}
`;

export const Header = styled.h4`
	font-weight: 600;
	text-align: center;
	font-size: 24px;
	line-height: 33px;
	letter-spacing: -1px;
	color: ${getColor("gray")};
	margin: 0;
	/* stylelint-disable */
	${props => props.pushDown && css`
		margin-bottom: 15px;
	`}
	/* stylelint-enable */
`;

export const SubHeader = styled.h6`
	margin: 0;
	color: ${getColor('gray8')};
	font-size: 15px;
	font-weight: 600;
	line-height: 20px;
	text-align: center;
	margin-bottom: 15px;
`;

export const GuestCheckoutText = styled.h4`
	font-size: 18px;
	font-weight: 700;
	text-align: center;
	line-height: 20px;
	color: ${getColor('gray')};
`;

export const OrDivider = styled.span`
	display: block;
	width: 100%;
	height: 20px;
	margin: 10px auto;
	text-align: center;
	position: relative;
	line-height: 1;

	&:before {
		${size('100%', 1)};
		position: absolute;
		top: 50%;
		left: 0;
		content: '';
		background-color: ${getColor('gray3')};
	}

	&:after {
		content: 'OR';
		padding-left: 10px;
		padding-right: 10px;
		background-color: ${getColor('white')};
		${align};
		color: ${getColor('gray9')};
		font-size: 12px;
		display: block;
	}
`;

export const Form = styled.form`
	position: relative;
`;
